/*
 * @Author: luting
 * @Date: 2022-04-12 11:03:43
 * @lastEditors: luting
 * @LastEditTime: 2023-03-16 13:28:35
 */
import React from 'react';
import cancelPic from 'root/assets/images/illustrator_cancel.png';
import messages from './messages';
import { useIntl } from 'react-intl';
import { Button } from 'sup-ui';

import styles from './index.less';

const CancelInstall = () => {
  const intl = useIntl();

  const clickBtn = () => {
    window.isBeforeunloadTip = false;
    window.hashHistory.push('/instances');
  };

  return (
    <div className={styles.installCancel}>
      <img className={styles.img} src={cancelPic} />
      <p className={styles.cancelTip}>{intl.formatMessage(messages.installCancel)}</p>
      <Button type="primary" onClick={clickBtn}>
        {intl.formatMessage(messages.cancelSure)}
      </Button>
    </div>
  );
};

export default CancelInstall;
